import React from 'react';
import TitleAlt from '../TitleAlt';

const LinkImageFooter = ({ Link, ImageFooter }) => (
    <a target="_blank" rel="noreferrer" href={Link}>
        <img className="image-footer" src={ImageFooter} alt={TitleAlt} />
    </a>
)

export default LinkImageFooter